import { render, staticRenderFns } from "./program_select_box.vue?vue&type=template&id=671495a6&"
import script from "./program_select_box.vue?vue&type=script&lang=js&"
export * from "./program_select_box.vue?vue&type=script&lang=js&"
import style0 from "./program_select_box.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports